import { library } from "../../libraries"

export interface NewsletterFormBlockProps {
  readonly kind: "newsletterForm"
}

export const NewsletterFormBlock =
  (props: NewsletterFormBlockProps) => library().newsletterBlock(props)